<template>
  <div class="modal fade" id="addDevice" tabindex="-1" aria-labelledby="addDeviceLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content text-center">
        <div class="modal-body">
          <img class="img-fluid" src="imgs/dashboard/modal-download.svg" alt="download app" />
          <h3>Download our Apps on every platform</h3>
          <p>Stay connected with coinsurf no matter which platform you use</p>
          <div
              class="download-btns d-flex flex-column flex-md-row align-items-center text-center justify-content-between">
            <a href="https://coinsurf.com/downloads/v1.1.2-win/coinsurf-1.1.2.exe" download>
              <svg class="me-2" width="19" height="19" viewBox="0 0 19 19" fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M8.37122 0.137939H0.043457V8.4138H8.37122V0.137939ZM18.0869 0.137939H9.75918V8.4138H18.0869V0.137939ZM9.75918 9.79311H18.0869V18.069H9.75918V9.79311ZM8.37122 9.79311H0.043457V18.069H8.37122V9.79311Z"
                      fill="#20244F" />
              </svg>
              <span>Download for Windows</span>
            </a>
            <a href="https://coinsurf.com/downloads/v1.0.3-mac/coinsurf-1.0.3-arm64.pkg" download>
              <svg class="me-2" style="position: relative; top: -3px" width="19" height="22" viewBox="0 0 19 22"
                   fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M13.687 0.777266C13.687 1.87906 13.1965 2.98085 12.5032 3.77492C11.7675 4.65506 10.4945 5.30925 9.48231 5.30925C9.36638 5.30925 9.25045 5.29419 9.17911 5.28128C9.16573 5.22748 9.13675 5.05963 9.13675 4.89177C9.13675 3.77492 9.72978 2.67313 10.3652 1.9759C11.1744 1.06993 12.5166 0.385613 13.6447 0.344727C13.6736 0.469539 13.687 0.624479 13.687 0.777266ZM17.6645 7.71692C17.6922 7.69937 17.7112 7.68733 17.7201 7.68069C16.2174 5.60191 13.9345 5.54596 13.2991 5.54596C12.3271 5.54596 11.4569 5.87873 10.7257 6.15838C10.1957 6.36107 9.73865 6.53586 9.36861 6.53586C8.95959 6.53586 8.49132 6.35333 7.9688 6.14967C7.30936 5.89263 6.56351 5.60191 5.74132 5.60191C2.96791 5.60191 0.149902 7.82056 0.149902 12.0039C0.149902 14.6121 1.19105 17.3601 2.47966 19.129C3.59215 20.6354 4.55972 21.862 5.94643 21.862C6.60394 21.862 7.08603 21.6646 7.59303 21.457C8.1553 21.2268 8.74822 20.984 9.64506 20.984C10.5515 20.984 11.0931 21.212 11.6153 21.4319C12.1013 21.6365 12.5705 21.834 13.3013 21.834C14.8173 21.834 15.8139 20.5105 16.7681 19.185C17.8382 17.6786 18.2863 16.2002 18.2997 16.1314C18.2128 16.1034 15.3078 14.9736 15.3078 11.7801C15.3078 9.20865 17.2882 7.95509 17.6645 7.71692Z"
                      fill="#20244F" />
              </svg>
              <span>Download for MacOS</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AddDevice"
}
</script>
